module.exports = __webpack_public_path__ + "static/media/ONE.44422e68.svg";